var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#8BA9B0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(11 11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,10 C18,5.589 14.411,2 10,2 C5.589,2 2,5.589 2,10 C2,14.411 5.589,18 10,18 C14.411,18 18,14.411 18,10 M20,10 C20,15.523 15.523,20 10,20 C4.477,20 0,15.523 0,10 C0,4.477 4.477,0 10,0 C15.523,0 20,4.477 20,10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91899781,13.5889507 C9.45609341,13.5889507 9.89199708,14.0170257 9.89199708,14.5444753 C9.89199708,15.0719249 9.45609341,15.5 8.91899781,15.5 C8.38190221,15.5 7.94599854,15.0719249 7.94599854,14.5444753 C7.94599854,14.0170257 8.38190221,13.5889507 8.91899781,13.5889507 Z M12.5288251,4.5 C13.3412795,4.5 14,5.1468902 14,5.9447533 L14,8.32209868 C14,9.37317582 13.1243007,10.233148 12.0540015,10.233148 L10.6032595,10.233148 C10.3298468,10.233148 10.1080029,10.4510076 10.1080029,10.7195101 L10.1080029,11.6779013 C10.1080029,12.2053509 9.67307225,12.633426 9.13500365,12.633426 C8.59790805,12.633426 8.16200438,12.2053509 8.16200438,11.6779013 L8.16200438,10.0210215 C8.16200438,9.08269632 8.9365118,8.32209868 9.89199708,8.32209868 L10.8649964,8.32209868 C11.4020919,8.32209868 11.8379956,7.89402363 11.8379956,7.36657401 C11.8379956,6.83912439 11.4020919,6.41104934 10.8649964,6.41104934 L6.97299927,6.41104934 C6.43590367,6.41104934 6,5.98297429 6,5.45552467 C6,4.92807505 6.43590367,4.5 6.97299927,4.5 L12.5288251,4.5 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.30497586.svg";
export { ForwardRef as ReactComponent };